import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';


const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

async function updateStatusAuctions(payload) {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    };

    const { data } = await axios.post(`${endpoint}/status-auctions`, payload, config);
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return {
      status: false,
      message: error.response?.data?.message || "Something went wrong",
      code: error.response?.status || 500,
    };
  }
}


export {
  updateStatusAuctions
  
};
